import React, { useEffect } from "react"
import { Col, Container, Row } from "react-bootstrap"
import Header from "components/Header/Header"
import AppButton from "components/StyledComponents/AppButton"
import { useHistory } from "react-router-dom"
import { useState } from "react"
import { createBreadcrumbs } from "helpers/breadCrumbs"
import { useDispatch, useSelector } from "react-redux"
import ContestDetails from "../components/ContestDetails"
import WeeklyQuizQuestions from "../components/ContestDetails/WeeklyQuizQuestions"
import { getViewQuizQuestionsAction, viewWeeklyQuizAction } from "redux/marketing/actions"
import { marketingActions } from "redux/marketing/slice/user"

function ViewWeeklyQuiz() {
  const dispatch = useDispatch()
  const [breadCrumbs, setBreadcrumbs] = useState([])
  const history = useHistory()
  const { weeklyQuizData, quizQuestions, quizQuestionsCount } = useSelector(
    (store) => store?.marketing
  )

  const handleEditContest = () => {
    dispatch(marketingActions.setIsContestEdited(false))
    history.push("/learning_development/dashboard/weekly-challenge/weekly-quiz/edit")
  }

  useEffect(() => {
    setBreadcrumbs(createBreadcrumbs())
    document.title = "Weekly Quiz"
    dispatch(viewWeeklyQuizAction())
    dispatch(getViewQuizQuestionsAction())
  }, [])

  const styles = {
    btn: {
      paddingLeft: "67px",
      paddingRight: "67px"
    }
  }

  return (
    <Container fluid className="ps-4 pe-4">
      <Row>
        <Col lg="12" className="ps-0">
          <Header title={weeklyQuizData?.name ?? "View Quiz"} breadCrumbs={breadCrumbs}>
            {weeklyQuizData?.status?.toLowerCase() === "draft" && (
              <AppButton onClick={handleEditContest} styles={styles.btn}>
                Edit Contest
              </AppButton>
            )}
          </Header>
        </Col>
      </Row>
      <Row>
        <Col lg="12">
          <Row>
            <ContestDetails contestDetails={weeklyQuizData} />
          </Row>
          <Row>
            <WeeklyQuizQuestions questions={quizQuestions} questionCount={quizQuestionsCount} />
          </Row>
        </Col>
      </Row>
    </Container>
  )
}

export default ViewWeeklyQuiz
